import { Box } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { HandByeIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { TextBold } from 'UiKit/typography';

import styles from './styles.module.css';

const HelpButton = ({ isHideNavBar, isLivestreaming }) => {
  const { t } = useTranslation('host-home');
  const navigate = useNavigate();
  const { pathname } = useLocation('host-home');

  const handleNavigateHelpRequest = () => {
    navigate('/host/help-request-form');
  };

  const isFullButton = pathname === '/host/stream' || (pathname === '/host' && !isLivestreaming);
  const isScheduleDetailPage = pathname.startsWith('/host/detail');
  const isStreamPage = pathname === '/host/stream';

  const bottomPosition = isStreamPage ? '96px' : !isHideNavBar || isScheduleDetailPage ? '72px' : '40px';

  return (
    <Box className={styles['help-button__container']} bottom={bottomPosition} padding={isFullButton ? '16px 20px' : '16px'} onClick={handleNavigateHelpRequest}>
      <HandByeIcon color="var(--color-semantic-white)" size="20" />
      <Condition statement={isFullButton}>
        <TextBold color="var(--color-semantic-white)" fontSize="14">
          {t('navbar.ask_for_help')}
        </TextBold>
      </Condition>
    </Box>
  );
};

export default HelpButton;
